import { DOCUMENT } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cookies-disabled',
  templateUrl: './cookies-disabled.component.html',
  styleUrls: ['./cookies-disabled.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class CookiesDisabledComponent {
  private document = inject<Document>(DOCUMENT);

  private window: Window & typeof globalThis;

  public constructor() {
    this.window = this.document.defaultView;
  }

  /**
   * Reloads the page.
   */
  public reloadPage(): void {
    this.window.location.reload();
  }
}
